import Average from './Average';
import CategoryChart from './CategoryChart';
import { useCategoryContext } from '../CategoryProvider';
import RadioGroupTipType from '../../../../Common/RadioGroupTipType';

import styles from './index.module.scss';
import { useState } from 'react';
import { SubCategoryTipStatisticsData } from '../../../../../hooks/api/subCategoryTip';

const SubCategoryBarChart = () => {
  const { subCategory, displayMode, setDisplayMode } = useCategoryContext();
  const [subCategoryTipStatisticsData, setSubCategoryTipStatisticsData] =
    useState<SubCategoryTipStatisticsData | null>(null);

  if (!subCategory) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <RadioGroupTipType value={displayMode} onChange={setDisplayMode} />
        <Average
          subCategoryTipStatisticsData={subCategoryTipStatisticsData}
          displayMode={displayMode}
        />
      </div>
      <div className={styles.chart}>
        <CategoryChart
          displayMode={displayMode}
          subCategoryId={subCategory.id}
          setAverageData={setSubCategoryTipStatisticsData}
        />
      </div>
    </div>
  );
};

export default SubCategoryBarChart;
